//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import PoapCreateModule from '../content/transfers/poap-create';

import { UserForm } from "../services/srvc-utilities";

export default function PoapsCreate() {

  return (
  <>
    <ContentFormatXX 
      head='Create POAP'
      link={`/${UserForm()}/poap`}
      form= 'mini'
      data= {
        <>
          <WebbDividerSmall />
          <PoapCreateModule />


        </>
      } 
    />
  </>
  )
}